import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    zone: undefined,
    cropType: undefined,
    productType: undefined,
    comparisons: [],
    technology: undefined,
    cropProtectionTargetSearch: '',
    sortField: undefined,
};

export default createReducer(initial, {
    [actions.resetProductSelection]: (state) => {
        return {
            ...state,
            zone: initial.zone,
            cropType: initial.cropType,
            productType: initial.productType,
            cropProtectionTargetSearch: initial.cropProtectionTargetSearch,
            sortField: initial.sortField,
        };
    },
    [actions.resetProductDetail]: (state) => {
        return { ...state, comparisons: initial.comparisons };
    },
    [actions.setCatalogZone]: (state, action) => {
        return { ...state, zone: action.payload };
    },
    [actions.setCatalogComparisons]: (state, action) => {
        return { ...state, comparisons: action.payload };
    },
    [actions.setCatalogCropType]: (state, action) => {
        return { ...state, cropType: action.payload };
    },
    [actions.setCatalogProductType]: (state, action) => {
        return { ...state, productType: action.payload };
    },
    [actions.setTechnology]: (state, action) => {
        return { ...state, technology: action.payload };
    },
    [actions.setCropProtectionTargetSearch]: (state, action) => {
        return { ...state, cropProtectionTargetSearch: action.payload };
    },
    [actions.setCatalogSortField]: (state, action) => {
        return { ...state, sortField: action.payload };
    },
    [actions.clean]: (state, action) => {
        return { ...state, ...initial };
    },
    [actions.deleteTechnology]: (state, action) => {
        return { ...state, technology: undefined };
    },
    [actions.resetProductComparison]: (state) => {
        return { ...state, comparisons: [] };
    },
});
